import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import { RealtimeProvider } from '@/components/RealtimeProvider'

export default function Layout() {
  return (
    <RealtimeProvider>
      <div className="flex flex-1 h-full min-h-0 bg-background">
        {/* Sidebar - fixed overlay on mobile, relative on desktop */}
        <Sidebar />

        {/* Main Content - full width on mobile, adjusted on desktop */}
        <div className="flex-1 flex flex-col min-h-0 min-w-0 overflow-hidden">
          <Header />
          <main className="flex-1 min-h-0 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </RealtimeProvider>
  )
}
